import React, {useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import "./PredictAfconTeams.css";
import { ImgURL } from "../../globalData";
import api from "../../apis";
import { getUserPhoneNumbers } from "../../globalFn";
import LoadingSpinnner from "../loadingSpinner/loadingSpinner";
import RequireSubscription from "../require-subscription";
import { Link, useLocation } from "react-router-dom";
import useServiceAndSport from "../../hooks/useServiceAndSport";
import notSubscriberImage from "../../../src/assets/not-Subscriber.jpeg";
import subscriberImage from "../../../src/assets/subscriber.jpeg";

function PredictAfconTeams(props) {
  const { pathname } = useLocation();
  let { serviceName } = useServiceAndSport();
  if (serviceName === "africa") serviceName = "meloukelkora";
  const { team1, team2,matchId } = props.el;
  const [isFetchingPredictAndWinStatus, setIsFetchingPredictAndWinStatus] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showSubscripedImage, setShowSubscripedImage] = useState(false);
   const [predictAndWinErrors, setPredictAndWinErrors] = useState(null) 
  const [formValues, setFormValues] = useState({ team_one: "", team_two: "" });
  const phoneNum = getUserPhoneNumbers()[0];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsFetchingPredictAndWinStatus(true);
    api.predictAndWin
      .sendUserPrediction({
        team_one: +formValues.team_one,
        team_two: +formValues.team_two,
        match_id : matchId,
        msisdn: phoneNum ?? null,
        team_one_id: team1.id,
        team_two_id: team2.id,
      })
      .then((res) => {
        if (res?.data?.status === 201 && phoneNum) {
          setShowSubscripedImage(true);
          props.reftechpredictionfn();
        } 
        
        else if((res?.predicted || res?.data?.status === 201) && !phoneNum) {
          /*not register phone number */
          setShowImage(true);
        }
        else {
        /* error */
          setPredictAndWinErrors(true)
        }

        setIsFetchingPredictAndWinStatus(false);

      });
  };
  useEffect(() =>  {
    
    if(!props.show) {
      setShowSubscripedImage(false);
      setShowImage(false);
      setPredictAndWinErrors(null)
      setFormValues({ team_one: "", team_two: "" })
    }

  },[props.show])
 

  return (
    <Modal
      {...props}
      size='xl'
      contentClassName={["modal__content", "predict-and-win-modal"]}
      dialogClassName='modal__dialog'
      data-testid='predict-and-win-modal'>
      <Modal.Header className='modal__header' closeButton />
      <Modal.Body className='show-grid'>
        <Container>
          {!!phoneNum && (
            <Row className='justify-content-center'>
              {/* <Col xs={12} className='modal__bodyTitle text-center text-white'>
                توقع النتيجة واكسب مع تويست سبورتس
          </Col>*/}
              {isFetchingPredictAndWinStatus && (
                <div className='my-5'>
                  <LoadingSpinnner
                    p={3}
                    fs={"md"}
                    loadingText='يتم الإرسال ...'
                  />
                </div>
              )} 
              {!isFetchingPredictAndWinStatus && !showSubscripedImage && !predictAndWinErrors && (
                <Col xs={10}>
                  <form className='predict__resultForm' onSubmit={handleSubmit}>
                    <div className='d-flex flex-column align-items-center'>
                      <figure className='d-flex flex-column align-items-center mb-4'>
                        <img src={ImgURL(team1.logo)} alt='' />
                        <figcaption className='mt-3'>{team1.title}</figcaption>
                      </figure>
                      <div className='select__wrapper'>
                        <select
                          id='match-result'
                          name='team_one'
                          value={formValues.team_one}
                          onChange={handleChange}>
                          <option value=''>اختر هنا</option>
                          {[...Array(11).keys()].map((ele) => (
                            <option key={ele} value={ele}>
                              {ele}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                      <figure className='d-flex flex-column align-items-center mb-4'>
                        <img src={ImgURL(team2.logo)} alt='' />
                        <figcaption className='mt-3'>{team2.title}</figcaption>
                      </figure>
                      <div className='select__wrapper'>
                        <select
                          id='match-result'
                          name='team_two'
                          value={formValues.team_two}
                          onChange={handleChange}>
                          <option value=''>اختر هنا</option>
                          {[...Array(11).keys()].map((ele) => (
                            <option key={ele} value={ele}>
                              {ele}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='button__wrapper text-center d-flex flex-column justify-content-center align-items-center'>
                      <Button type='submit' className='text-capitalize'>
                        إرسال
                      </Button>
                    </div>
                  </form>
                </Col>
              )}
              {!isFetchingPredictAndWinStatus && showSubscripedImage && (
                <Col xs={12} className='d-flex  flex-column align-items-center'>
                  <img src={subscriberImage} alt='' className='win' />
                  <p>تم إرسال توقعك</p>
                </Col>
              )}
            

              {!isFetchingPredictAndWinStatus && predictAndWinErrors && (
                <Col
                  xs={10}
                  className='text-center my-5 text-white d-flex flex-column justify-content-center'>
                  حدث خطا يرجي اعادة المحاولة
                </Col>
              )}
            </Row>
          )}

          {!phoneNum && (
            <Row className='justify-content-center'>
              {/* <Col xs={12} className='modal__bodyTitle text-center text-white'>
                <p>
                  عشان تكسب جوايز كتير من تويست سبورتس، اشترك في خدمة ملوك
                  الكورة.
                </p>
                <Link
                  className='fs-md btn btn-link fs-sm active-color text-decoration-underline subscribe-btn'
                  to={{
                    pathname: `/${serviceName ?? "meloukelkora"}/subscribe`,
                    state: {
                      previousPathname: pathname,
                    },
                  }}>
                  إشترك
                </Link>
              </Col> */}
              {isFetchingPredictAndWinStatus && (
                <div className='my-5'>
                  <LoadingSpinnner
                    p={3}
                    fs={"md"}
                    loadingText='يتم الإرسال ...'
                  />{" "}
                </div>
              )}
              {!isFetchingPredictAndWinStatus && !showImage && !predictAndWinErrors &&(
                <Col xs={10}>
                  <form className='predict__resultForm' onSubmit={handleSubmit}>
                    <div className='d-flex flex-column align-items-center'>
                      <figure className='d-flex flex-column align-items-center mb-4'>
                        <img src={ImgURL(team1.logo)} alt='' />
                        <figcaption className='mt-3'>{team1.title}</figcaption>
                      </figure>
                      <div className='select__wrapper'>
                        <select
                          id='match-result'
                          name='team_one'
                          value={formValues.team_one}
                          onChange={handleChange}>
                          <option value=''>اختر هنا</option>
                          {[...Array(11).keys()].map((ele) => (
                            <option key={ele} value={ele}>
                              {ele}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                      <figure className='d-flex flex-column align-items-center mb-4'>
                        <img src={ImgURL(team2.logo)} alt='' />
                        <figcaption className='mt-3'>{team2.title}</figcaption>
                      </figure>
                      <div className='select__wrapper'>
                        <select
                          id='match-result'
                          name='team_two'
                          value={formValues.team_two}
                          onChange={handleChange}>
                          <option value=''>اختر هنا</option>
                          {[...Array(11).keys()].map((ele) => (
                            <option key={ele} value={ele}>
                              {ele}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='button__wrapper text-center d-flex flex-column justify-content-center align-items-center'>
                      <Button
                        type='submit'
                        className='text-capitalize predictAfconAndWin-submit-button'
                        disabled={!formValues.team_two || !formValues.team_one}>
                        إرسال
                      </Button>
                    </div>
                  </form>
                </Col>
              )}

              {!isFetchingPredictAndWinStatus && showImage && (
                <Col xs={12} className='d-flex  flex-column align-items-center'>
                  <img src={notSubscriberImage} alt='' className='win' />
                  <Link
                    className='fs-md btn btn-link fs-sm active-color text-decoration-underline subscribe-btn'
                    to={{
                      pathname: `/${serviceName ?? "meloukelkora"}/subscribe`,
                      state: {
                        previousPathname: pathname,
                      },
                    }}>
                    إشترك
                  </Link>
                </Col>
              )}

              {!isFetchingPredictAndWinStatus && predictAndWinErrors && (
                <Col
                  xs={10}
                  className='text-center my-5 text-white d-flex flex-column justify-content-center'>
                  حدث خطا يرجي اعادة المحاولة
                </Col>
              )}

            </Row>
          )}
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default PredictAfconTeams;
